import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import Subbar from './Subbar';
import Footer from './Footer';
import { SideNavProvider } from '../context/SideNavContext';

// The application shell: a fixed full-width app bar over a fixed sidebar and a
// scrollable content region. On desktop the menu button collapses the sidebar
// to an icon rail; on mobile it opens the sidebar as an off-canvas drawer.
export default function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false); // mobile drawer
  const [railCollapsed, setRailCollapsed] = useState(false); // desktop rail

  const toggleNav = () => {
    if (window.matchMedia('(max-width: 780px)').matches) {
      setSidebarOpen((v) => !v);
    } else {
      setRailCollapsed((v) => !v);
    }
  };

  return (
    <SideNavProvider>
      <div className={`app ${railCollapsed ? 'app--rail' : ''}`}>
        <TopBar onToggleNav={toggleNav} />
        <Subbar onToggleNav={toggleNav} />
        <div className={`shell ${sidebarOpen ? 'shell--sidebar-open' : ''}`}>
          <Sidebar
            open={sidebarOpen}
            collapsed={railCollapsed}
            onCollapse={() => setRailCollapsed((v) => !v)}
          />
          <div
            className="shell__scrim"
            onClick={() => setSidebarOpen(false)}
            aria-hidden="true"
          />
          <div className="shell__main">
            <main className="shell__content">
              <Outlet />
            </main>
          </div>
        </div>
        <Footer />
      </div>
    </SideNavProvider>
  );
}
